import React, { useState, useEffect } from 'react'
import api from '../components/api'
//import Accordion from 'react-bootstrap/Accordion';
import Compras_VisaoEstrategica from '../components/Compras_VisaoEstrategica'
import Compras_EstruturaAdm from '../components/Compras_EstruturaAdm'
import Compras_Comunicacao from '../components/Compras_Comunicacao'
import Compras_Processo from '../components/Compras_Processo'

import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'

const Modal = (props) => {

    
    var adesao_institucional_id = props.adesao_institucional_id
    var ano = props.ano
    var compras_id = props.compras_id
    var formulario_id = props.formulario_id

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()


    const [totalCorrecoes, setTotalCorrecoes] = useState(0)
    const [totalEmails, setTotalEmails] = useState(0)


    const verificaValidacoes = () => {

        
        

        if (formulario_id) {

            var dataPost = {

                formulario_id: formulario_id,
                desafio: 'Compras',

            }

            //console.log(dataPost, '1!')

            api.post('desafioValidaVarios', dataPost).then((result) => {

                

                if (result.data) {

                    setTotalCorrecoes(result.data.length)
                    
                }
                
              

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    const listaEmailsCorrecoes = () => {

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data)
            setTotalEmails(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })

    }




    useEffect(() => {

        //console.log(formulario_id)

        verificaValidacoes()
        listaEmailsCorrecoes()
        
        

    }, [verificaDesafio, formulario_id])

    

    function validaCompras(opc) {


        var dataPost = {

            opc: opc,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            formulario_id: formulario_id,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma a ação?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
                    

                    api.put(`comprasValida`, dataPost).then((result) => {
                        
                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$("#modalCompras").modal('hide');
                            props.fnCompras()

                        } else {

                            window.toastr.error(result.data.alerta)
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    /*
    async function geraPDF() {


        api.get(`comprasPDF/${adesao_institucional_id}/${ano}`).then((result) => {

            if (result.data.arquivo) {

                window.open(`https://cdn.hospitaissaudaveis.org/pdf/${result.data.arquivo}`)

            } else {

                window.toastr.error(`Não foi possível gerar o PDF, provavelmente o preenchimento não está completo!`)
                return false

            }

        }).catch((err) => {

            console.log(err.response)

        })


    }
    */

    const geraPDF = async () => {

      window.toastr.info("Aguarde...");

      try {

      const response = await api.get(`comprasPDF/${adesao_institucional_id}/${ano}`, {
          responseType: "blob",
          validateStatus: (status) => true // para não cair direto no catch
      });

      if (response.status !== 200) {
          // ler como texto para ver o erro real
          const errorText = await response.data.text();
          console.error("Erro backend:", errorText);
          window.toastr.error("Erro ao exportar: " + errorText);
          return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `desafioCompras_${adesao_institucional_id}_${ano}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      window.toastr.success("Download concluído!");
      } catch (err) {
      console.error(err);
      window.toastr.error("Falha ao baixar arquivo");
      }
  };







    useEffect(() => {


        window.$('[href="#tabC1"]').tab('show');


    }, [ano, adesao_institucional_id])


    return (

        <div>


                <div className="modal fade" id="modalCompras" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document"  style={{ width: '95%'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Desafio Compras - Ano {ano}</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">


                                        <div class="row">
                                            
                                            <div class="col-sm-12">
                                                


                                                <ul class="nav nav-tabs">
                                                        <li class="active"><a href="#tabC1" data-toggle="tab">Seção I</a></li>
                                                        <li><a href="#tabC2" data-toggle="tab">Seção II</a></li>
                                                        <li><a href="#tabC3" data-toggle="tab">Seção III</a></li>
                                                        <li><a href="#tabC4" data-toggle="tab">Seção IV</a></li>
                                                        <li><a href="#tabC5" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                        <li><a href="#tabC6" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                                     
                                                </ul>

                                                <div class="tab-content">
                                                    <div class="tab-pane fade in active" id="tabC1">
                                                        <div class="panel-body">

                                                            <Compras_VisaoEstrategica adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabC2">
                                                        <div class="panel-body">

                                                            <Compras_EstruturaAdm adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabC3">
                                                        <div class="panel-body">

                                                            <Compras_Comunicacao adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabC4">
                                                        <div class="panel-body">

                                                            <Compras_Processo adesao_institucional_id={adesao_institucional_id} ano={ano} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabC5">
                                                        <div class="panel-body">

                                                            <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} ano={ano} origem="Compras" />

                                                        </div>

                                                    </div>
                                                    <div className="tab-pane fade in" id="tabC6">
                                                        <div className="panel-body">

                                                            <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} ano={ano}  origem="Compras" />
    .
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>


                                    </div>


                            </div>
                            <div className="modal-footer">


                                <button type="button" className="btn btn-danger" onClick={() => geraPDF()}>PDF</button>
                                <button type="button" className="btn btn-warning" onClick={() => validaCompras('A')}>Em análise</button>
                                <button type="button" className="btn btn-danger" onClick={() => validaCompras('P')}>Com pendências</button>
                                <button type="button" className="btn btn-primary" onClick={() => validaCompras('V')}>Completo</button>
                                <button type="button" className="btn btn-warning" onClick={() => validaCompras('Z')}>Verificado</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )



}


    

export default Modal